import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { API_BASE_URL_JSON, API_BASE_URL_V } from "src/app/data-wp.service";
import { emailData } from "src/app/shared/emailData";
import { SocioData } from "src/app/shared/socio-data.interface";

@Component({
  selector: "app-ampliacion-familiar",
  templateUrl: "./ampliacion-familiar.component.html",
  styleUrls: ["../../socios-gestion-online.component.css"],
})
export class AmpliacionFamiliarComponent implements OnInit {
  form: FormGroup;
  fechaHoy;
  hoy;
  @Output() closeModal = new EventEmitter();
  @ViewChild("modalRespuesta", { static: false }) modalRespuesta: ElementRef;

  constructor(
    public formBuilder: FormBuilder,
    private http: HttpClient,
    private modalService: NgbModal,
    private datepipe: DatePipe
  ) {}

  get nombre() {
    return this.contactForm.get("nombre");
  }
  get apellido() {
    return this.contactForm.get("apellido");
  }
  get fechaNac() {
    return this.contactForm.get("fechaNac");
  }
  get tipoDoc() {
    return this.contactForm.get("tipoDoc");
  }
  get nroDoc() {
    return this.contactForm.get("nroDoc");
  }

  contactForm = this.formBuilder.group({
    nombre: ["", [Validators.required]],
    apellido: ["", [Validators.required]],
    fechaNac: ["", [Validators.required]],
    tipoDoc: ["", [Validators.required]],
    nroDoc: ["", [Validators.required, Validators.pattern("[0-9]{7,8}")]],
  });

  datosSocio: SocioData;
  modalMessage: string;
  ngOnInit() {
    this.datosSocio = JSON.parse(sessionStorage.getItem("data"));
    this.fechaHoy = Date.now();
    this.hoy = this.datepipe.transform(this.fechaHoy, "yyyy-MM-dd");
    emailData[this.datosSocio.socio_dominio];
  }

  submitForm() {
    let formData = new FormData();
    let form = this.contactForm.value;
    formData.append("numero_afiliado", this.datosSocio.socio_numero);
    formData.append("nombre_afiliado", this.datosSocio.socio_nombre);
    formData.append("apellido_afiliado", this.datosSocio.socio_apellido);
    formData.append("email_afiliado", this.datosSocio.socio_email);
    formData.append("dominio_afiliado", this.datosSocio.socio_dominio);
    formData.append("nombre_adherente", form.nombre);
    formData.append("apellido_adherente", form.apellido);
    formData.append("nacimiento_adherente", form.fechaNac);
    formData.append("tipodni_adherente", form.tipoDoc);
    formData.append("dni_adherente", form.nroDoc);
    this.datosSocio.socio_dominio.length > 0
      ? formData.append(
          "email_destino",
          emailData[this.datosSocio.socio_dominio]
        )
      : formData.append("email_destino", "cas@vittal.com.ar");

    this.http
      .post<any>(
        API_BASE_URL_JSON + "/contact-form-7/v1/contact-forms/3711/feedback",
        formData
      )
      .subscribe((res) => {
        this.closeModal.emit();
        this.modalMessage = res.message;
        this.openModal(this.modalRespuesta);
      });
  }

  spanTop() {
    document.getElementById("areaSpan").classList.add("top");
    document.getElementById("contentSelect").classList.add("ok");
  }
  openModal(content) {
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      windowClass: "modal-socios-form",
    });
  }
}
